'use client'

import Icon from "@/components/etc/icon";
import closeIcon from "@/public/icon/close.svg"
import { nav } from "@/type/nav_types";
import MobileNav from "../navigation/mobileNav";

import { useContext, useEffect, useRef, useState } from "react";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import { AuthContext } from "@/context/authContext";
import { with_comma } from "@/util/comma";
import { usePathname, useRouter } from "next/navigation";
import FloatBtn from "../etc/float_btn";
import { BetContext } from "@/context/BetContext";
import { MessageContext } from "@/context/messageContext";
import ProfileLayout from "@/components/etc/profile";
import api from "@/util/api";
import { NavContext } from "@/context/navContext";

import PageBanner from "@/components_mobile/banner/page_banner"
import { DeviceContext } from "@/context/deviceContext";
import { BannerContext } from "@/context/bannerContext";
import VerifiedRankList from "../etc/verified_rank_list";
import VerifiedFavoriteList from "../etc/verified_favorite_list";
import logoutimage from "@/public/image/etc/logout.png"
import customAlert from "@/util/customAlert";
import LocaleSelect from "@/components/common/locale/locale_select";
import { useTranslations } from "next-intl";

export default function FloatMyPageRight({ isActive, setActive }: { isActive: boolean, setActive: Function }) {
    const { mypageShow, SetMypageShow, SetPasswordShow, setChangeProfileShow, myinfoShow, SetMyinfoShow } = useContext(SignContext)
    const { user, logout, messages, loading } = useContext(AuthContext)
    const { setBetDetailShow } = useContext(BetContext)
    const { SetMessageShow } = useContext(MessageContext)
    const router = useRouter()

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    function movePage(path: string) {
        SetMypageShow(false);
        router.push(path)
    }

    function handleLogout() {
        setActive(false)
        SetMypageShow(false)
        logout({ suppressRedirect: true });
    }

    const scrollRef = useRef<HTMLDivElement>(null)
    const headerRef = useRef<HTMLDivElement>(null)

    const { mobileMode, theme } = useContext(DeviceContext)
    const { page_top_banner, sub_bottom_banner } = useContext(BannerContext)

    const pathName = usePathname()

    useEffect(() => {
        const isUserLogout = sessionStorage.getItem('logoutInitiatedByUser') === '1';
        if (!loading) {
            if (!user.is_authenticated) {
                if (isUserLogout) return;
                router.push('/');
            } else {
                // router.push('/');
                // console.log("123123", user.is_authenticated, isUserLogout)
            }
        }
    }, [user, router]);



    useEffect(() => {
        setActive(false)
    }, [pathName])

    useEffect(() => {
        if (!headerRef.current) return;
        if (!scrollRef.current) return;

        const headerCurrent = headerRef.current
        const scrollCurrent = scrollRef.current

        const headerHeight = headerCurrent.clientHeight;
        scrollCurrent.style.height = `calc(100% - ${headerHeight}px)`
    }, [headerRef])

    useEffect(() => {
        if (!user.is_authenticated) {
            // router.push("/")   
        }
    }, [user, router])
    if (!user.is_authenticated) return null;

    // useEffect(() => {
    //     if (!user.is_authenticated && !justLoggedOut ) {
    //         router.push("/");
    //     }
    // }, [user, router, justLoggedOut]);
    // if (!user.is_authenticated && !justLoggedOut) return null;


    return (
        <>
            {isActive && <div className="float-left-menu-backdrop" onClick={e => setActive(false)}></div>}
            <div className={`float-right-mypage ${isActive ? "active" : ""}`}>

                <div className="float-mypage-container">
                    <div className="mypage-inner" >
                        <div className="flex between">
                            <Icon icon={`close`} onClick={e => setActive(false)} className="close-btn" />
                            <LocaleSelect mode={'wide'} />
                        </div>
                        <div className={`login-auth-new mypage-info`}>
                            <div className={`flex center`} style={{ flexWrap: "wrap" }}>
                                <div className={`img`} style={{ width: "90px" }}>
                                    <ProfileLayout />
                                </div>
                                <div className={`info`} style={{ width: "calc(100% - 90px)" }}>
                                    <div className={`flex center`}>
                                        <div className={`keep-word w-30-per --bold-600`}>{t("아이디")}</div>
                                        <div className={`keep-word w-70-per p-l-10`}>{user.id}</div>
                                    </div>
                                    <div className={`flex center`}>
                                        <div className={`keep-word w-30-per --bold-600`}>{t("닉네임")}</div>
                                        <div className={`keep-word w-70-per p-l-10`}>{user.nickname}</div>
                                    </div>
                                </div>

                                <div className="etc-wrap w-100-per m-l-0 m-b-10">
                                    <div className={`flex center etc`}>
                                        <div className={`w-33-per`}>
                                            <div>{t("레벨")}</div>
                                            <div>{with_comma(user.level)}</div>
                                        </div>
                                        <div className={`w-33-per`}>
                                            <div>{t("경험치")}</div>
                                            <div>{with_comma(user.exp)} EXP</div>
                                        </div>
                                        <div className={`w-33-per`}>
                                            <div>{t("포인트")}</div>
                                            <div>{with_comma(user.point)} P</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="btns  m-b-10">

                            {/* 그리드맞춰놓고 모바일 체크 하셔야합니다이잇 박스 넘어가버립니다요잇 */}
                            <div className={`flex between w-100-per wrap`}>
                                <button className={`w-49-per m-l-0 m-r-0 m-b-5`} onClick={e => SetMessageShow(true)}>{t("쪽지함")} <span>({messages.unread_count})</span></button>
                                <button className={`w-49-per m-l-0 m-r-0 m-b-5`} onClick={e => movePage('/pointexchange/sponmd/')}>{t("포인트 전환")}</button>
                                {/* <button className={`w-49-per m-l-0 m-r-0 m-b-5`} onClick={e => SetPasswordShow(true)}>비밀번호 변경</button> */}
                                <button className={`w-49-per m-l-0 m-r-0 m-b-5`} onClick={e => { setActive(false); movePage("/notice/") }}>{t("공지사항")}</button>
                                <button className={`w-49-per m-l-0 m-r-0 m-b-5`} onClick={e => SetMyinfoShow(true)}>{t("내정보 변경")}</button>
                            </div>
                            <div className={`flex center m-t-3`} style={{ display: "block" }}>
                                <button onClick={handleLogout}
                                    className={`w-100-per logoutBtn m-l-0 m-r-0 ${theme == "light" ? "login" : "sign-in"}`} >
                                    <span>{t("로그아웃")}</span>
                                    <img src={logoutimage.src} />
                                </button>
                            </div>
                        </div>
                    </div>

                    <InqueryFooter />
                    <div className={`p-b-50`}>
                        <VerifiedRankList setActive={setActive} />

                        <VerifiedFavoriteList setActive={setActive}
                            className={`mypage_info_favorites`} />
                    </div>
                </div>
            </div>
        </>
    )
}
